<template>
  <div class="stat-pie-percentage-part">
    <b>{{ fNum.format(data.Count) }}</b>
    <CmPiePercentage
      v-if="!onlyText"
      :key="id"
      :cid="id"
      :percent="data.Percent"
      :color="color"
      :text="additionalText"
    />
  </div>
</template>

<script>
import CmPiePercentage from "@/components/library/statistics/elements/CmPiePercentage.vue";

export default {
  name: "PiePercentagePart",

  components: {
    CmPiePercentage
  },

  props: {
    id: {
      type: String
    },
    data: {
      type: Object,
      default: () => ({
        Count: 0,
        Percent: 0
      })
    },
    color: {
      type: String
    },
    onlyText: {
      type: Boolean,
      default: false
    },
    additionalText: {
      type: String,
      default: ""
    }
  }
}
</script>

<style lang="scss">
.stat-pie-percentage-part {
  min-width: 150px;
  padding-bottom: 5px;
  .cm-pie-percentage {
    margin-left: -8px;
  }
}
</style>
